module.exports = __webpack_public_path__ + "img/expirationReminder.7101bd7d.webp";